import { SITE_NAME } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Hero() {
  return (
    <section className="fm-hero" id="top" aria-label="Hero">
      <div className="fm-container">
        <div className="fm-hero__content">
          <p className="fm-kicker">Design &amp; marketing software</p>
          <p className="fm-hero__brand">{SITE_NAME}</p>
          <h1 className="fm-hero__title">
            Design software and digital marketing tools for modern teams.
          </h1>
          <p className="fm-hero__sub">
            Equip your studio with creative software and growth tools — clear
            licences, fast delivery, and support when you need it.
          </p>
          <div className="fm-hero__actions">
            <button
              type="button"
              className="fm-btn fm-btn--primary"
              onClick={openZohoChat}
            >
              Chat with us
            </button>
            <a className="fm-btn fm-btn--outline" href="#products">
              Browse software
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
